import firebase from "firebase/app";
import "firebase/firestore";

// Initialize Firebase
// var config = {
//   apiKey: "AIzaSyCzJDGJluob9tzQ19O6hMFbLDho4LIurkE",
//   authDomain: "ccms-application.firebaseapp.com",
//   databaseURL: "https://ccms-application.firebaseio.com",
//   projectId: "ccms-application",
//   storageBucket: "ccms-application.appspot.com",
//   messagingSenderId: "239479374163",
//   appId: "1:239479374163:web:5ef42817b36b267e"
// };

var config = {
  apiKey: "AIzaSyD10wx5P55Zu06W7CUVpFXS4F02tvWohaA",
authDomain: "ccmsweb-8d7c9.firebaseapp.com",
databaseURL: "https://ccmsweb-8d7c9.firebaseio.com",
projectId: "ccmsweb-8d7c9",
storageBucket: "ccmsweb-8d7c9.appspot.com",
messagingSenderId: "125722893993",
appId: "1:125722893993:web:ec252f2e533a6081ebd3b8",
measurementId: "G-SQQCL0LRC7"
};

const firebaseApp = firebase.initializeApp(config);
export default firebaseApp.firestore();
